function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 50"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M49.51 25h-5.32a5.327 5.327 0 00-5.322 5.333v5.334A5.327 5.327 0 0044.189 41a5.327 5.327 0 005.322-5.333V25zm0 0c0-13.255-10.72-24-23.946-24S1.617 11.745 1.617 25v10.667A5.327 5.327 0 006.94 41a5.327 5.327 0 005.321-5.333v-5.334A5.327 5.327 0 006.94 25H1.617"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M49.512 30.333V41c0 5.333-1.774 8-5.322 8H30.887"
})));